import moment = require('moment');
import {Moment} from 'moment';
import {map} from 'lodash';
import {QuoteStatus} from '../data/api/models';
const DATE_FORMAT = 'DD/MM/YYYY';
const PRODUCT_NAME = 'Agricultural Vehicles';

const proRataFactor = (startDate: Moment) => {
  const backdatedCover = startDate.isBefore(
    moment().subtract(1, 'day').startOf('day'),
  );

  // adjust end date to end of year
  // startDate < moment(moment().year() + '-12-10').format()
  const endDate = startDate.isBefore(
    moment()
      .month(11) // december
      .date(10)
      .startOf('day'),
  ) ?
    moment()
      .month(11) // december
      .date(31)
      .startOf('day')
    :
    moment()
      .add(1, 'y')
      .month(11) // december
      .date(31)
      .startOf('day');

  return {
    endDate,
    startDate,
    backdatedCover,
  };
};

const displayCurrency = (value, separator = ' ', noPennies = false) => {
  if (!value && value !== 0.00) {
    return '';
  }
  return parseFloat(value).toFixed(noPennies ? 0 : 2).replace(/\B(?=(\d{3})+(?!\d))/g, separator);
};

const dateFromApi = (date) => {
  if (! date) {
    return '';
  }

  const parsedDate = moment(date).format('DD/MM/YYYY');

  return parsedDate !== 'Invalid Date' ? parsedDate : '';
};

const dateToApi = (date) => {
  if (! date) {
    return '';
  }

  const formattedDate = moment(date, 'DD/MM/YYYY').format();
  // .utcOffset(0, true).format();
  return formattedDate.toLowerCase() !== 'invalid date' ? formattedDate : '';
};

const getReferralsAndDeclines = (quote) => {
  const result = {
    declines: [],
    referrals: [],
    errors: [],
    empty: true,
    enableLinkOnTabs: ['validation'],
  };

  const availableQuote = getAvailableQuote(quote);

  if (! availableQuote.length) {
    return result;
  }

  result.declines = availableQuote[0].declines;
  if (quote.application.status !== QuoteStatus.REFERRAL_APPROVED) {
    result.referrals = availableQuote[0].referrals;
  }

  result.errors = availableQuote[0].errors;
  result.empty = result.declines.length + result.referrals.length === 0;

  return result;
};

const getAvailableQuote = (quote) => {
  const availableQuote = [];

  const quotes = quote.quotes.standard && quote.quotes.standard;
  if (! quotes) {
    return availableQuote;
  }
  map(quotes, (quote, key) => {
    availableQuote.push(quote);
  });

  return availableQuote;
};

const translateStatus = (status) => {
  return QuoteStatus.translate(status);
};

const translatePaymentError = (message) => {
  message = message.replace('Card Payment was unsuccessful: ', '');
  if (message === 'There was an error processing the payment.') {
      return 'Numéro de carte invalide';
  }
  return message;
};

const translatePasswordError = (message) => {
  switch (message) {
    case 'No password supplied':
      return 'Veuillez entrer votre mot de passe.';
    case 'Password must be at least 10 characters':
      return 'Le mot de passe doit contenir au moins 10 caractères.';
    case 'Password must contain both upper and lower case characters':
      return 'Le mot de passe doit contenir une minuscule et une majuscule.';
    case 'Password must contain at least one number':
      return 'Le mot de passe doit contenir au moins un chiffre.';
    case 'Password must contain at least one non-alphanumeric character':
      return 'Le mot de passe doit contenir au moins un caractère spécial.';
    case 'User is not a Customer':
      return 'Vous utilisez des identifiants d’accès au back office.';
    case 'Reset token has expired, please request a new password reset email.':
      return 'Le lien a expiré. Veuillez réinitialiser votre mot de passe en cliquant sur « connexion client »' +
        ' en haut de cette page.';
    case 'Credentials do not match the account':
      return 'Vos identifiants sont incorrects, merci de les entrer à nouveau.';
    case 'User email address is already being used':
      return 'L\'adresse électronique est déjà utilisée';
  }
  return message;
};

const pascalCase = (s) => {
  return s.replace(/\w+/g, (w) => {
    return w[0].toUpperCase() + w.slice(1).toLowerCase();
  });
};

const lowerCase = (value) => value ? value.toLowerCase() : value;

const displayCustomerType = (s) => {
  switch (s) {
    case 'company':
      return 'Company';
    case 'individual':
      return 'Individual';
    case 'joint':
      return 'Joint Names';
    default:
      return '';
  }
};

const weightBandingDetection = (weight) => {
  if (!weight) {
    weight = 0;
  }
  if (weight <= 3.5) {
    return '0T - 3.50T';
  }
  if (weight <= 7.5) {
    return '3.51T - 7.50T';
  }
  if (weight <= 12.5) {
    return '7.51T - 12.50T';
  }
  if (weight <= 18) {
    return '12.51T - 18.00T';
  }
  if (weight <= 26) {
    return '18.01T - 26.00T';
  }
  if (weight <= 32) {
    return '26.01T - 32.00T';
  }
  if (weight <= 38) {
    return '32.01T - 38.00T';
  }
  return '38.01T and over';
};

export {
  DATE_FORMAT,
  PRODUCT_NAME,
  proRataFactor,
  displayCurrency,
  dateFromApi,
  dateToApi,
  getReferralsAndDeclines,
  getAvailableQuote,
  translateStatus,
  pascalCase,
  lowerCase,
  translatePaymentError,
  translatePasswordError,
  displayCustomerType,
  weightBandingDetection,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/util/helpers.ts